import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from "react-toastify";
import Header from './Header';
import { Button, TextField, Container, Typography, Box, CircularProgress } from '@mui/material';

function VerifyEmail() {
    const [otp, setOtp] = useState("");
    const [isLoading, setIsLoading] = useState(false); // Loading state for Verify OTP
    const [email, setEmail] = useState(""); // To hold the user's email for resending OTP
    const [isResending, setIsResending] = useState(false); // Loading state for Resend OTP
    const navigate = useNavigate(); 
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (otp) {
            setIsLoading(true);
            try {
                const response = await axios.post(`${apiUrl}/api/v1/auth/verify-email/`, { otp });
                toast.success(response.data.message);
                navigate('/login');
            } catch (error) {
                toast.error(error.response?.data?.message || "An error occurred while verifying your email.");
            } finally {
                setIsLoading(false);
            }
        } else {
            toast.error("Please enter the OTP.");
        }
    };

    // const handleResendOtp = async () => {
    //     try {
    //         const response = await axios.post(`${apiUrl}/api/v1/auth/resend-otp/`, { email });
    //         toast.success(response.data.message);
    //     } catch (error) {
    //         toast.error(error.response?.data?.message || "An error occurred while resending the OTP.");
    //     }
    // };

    const handleResendOtp = async () => {
        if (!email) {
          toast.error("Please enter your email.");
          return;
        }
        setIsResending(true);
        try {
          const response = await axios.post(`${apiUrl}/api/v1/auth/resend-otp/`, { email });
          toast.success(response.data.message);
        } catch (error) {
          toast.error(error.response?.data?.message || "An error occurred while resending the OTP.");
        } finally {
          setIsResending(false);
        }
    };

    return (
        <>
            <Header />
            <Container maxWidth="sm" sx={{ mt: 4 }}>
                <Typography variant="h4" align="center" gutterBottom>
                    Verify Your Email
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="OTP"
                        variant="outlined"
                        fullWidth
                        required
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        sx={{ mb: 2 }}
                    />
                    <Button 
                        type="submit" 
                        variant="contained" 
                        color="primary" 
                        fullWidth
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Verify OTP"}
                    </Button>
                </form>
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
                    <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{ mr: 2 }}
                    />
                    {/* <Button variant="outlined" color="secondary" onClick={handleResendOtp}>
                        Resend OTP
                    </Button> */}
                    <Button 
                      variant="outlined" 
                      color="secondary" 
                      onClick={handleResendOtp}
                      disabled={isResending}
                    >
                      {isResending ? <CircularProgress size={24} color="inherit" /> : "Resend OTP"}
                    </Button>
                </Box>
            </Container>
        </>
    );
}

export default VerifyEmail;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { toast } from "react-toastify";
// import Header from './Header';
// import { Button, TextField, Container, Typography, Box } from '@mui/material';

// function VerifyEmail() {
//     const [otp, setOtp] = useState("");
//     const [email, setEmail] = useState(""); // To hold the user's email for resending OTP
//     const navigate = useNavigate(); 
//     const apiUrl = process.env.REACT_APP_API_URL;

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (otp) {
//             try {
//                 const response = await axios.post(`${apiUrl}api/v1/auth/verify-email/`, { otp });
//                 if (response.status === 200) {
//                     toast.success(response.data.message);
//                     navigate('/login');
//                 }
//             } catch (error) {
//                 // Handle error responses
//                 toast.error(error.response.data.message || "An error occurred while verifying your email.");
//             }
//         } else {
//             toast.error("Please enter the OTP.");
//         }
//     };

//     const handleResendOtp = async () => {
//         try {
//             const response = await axios.post(`${apiUrl}api/v1/auth/resend-otp/`, { email });
//             if (response.status === 200) {
//                 toast.success(response.data.message);
//             }
//         } catch (error) {
//             toast.error(error.response.data.message || "An error occurred while resending the OTP.");
//         }
//     };

//     return (
//         <>
//         <Header />
//         <Container maxWidth="sm" sx={{ mt: 4 }}>
//             <Typography variant="h4" align="center" gutterBottom>
//                 Verify Your Email
//             </Typography>
//             <form onSubmit={handleSubmit}>
//                 <TextField
//                     label="OTP"
//                     variant="outlined"
//                     fullWidth
//                     required
//                     value={otp}
//                     onChange={(e) => setOtp(e.target.value)}
//                     sx={{ mb: 2 }}
//                 />
//                 <Button type="submit" variant="contained" color="primary" fullWidth>
//                     Verify OTP
//                 </Button>
//             </form>
//             <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
//                 <TextField
//                     label="Email"
//                     variant="outlined"
//                     fullWidth
//                     required
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     sx={{ mr: 2 }}
//                 />
//                 <Button variant="outlined" color="secondary" onClick={handleResendOtp}>
//                     Resend OTP
//                 </Button>
//             </Box>
//         </Container>
//         </>
//     );
// }

// export default VerifyEmail;
